import { Tabs } from '@mantine/core'
import GemzTable from './GemzTable'
import TagsManager from './TagsManager'

function CommunityGemzTab() {
  return (
    <Tabs defaultValue='gemz' mt='md'>
      <Tabs.List>
        <Tabs.Tab value='gemz'>Gemz</Tabs.Tab>
        <Tabs.Tab value='tags'>Tags</Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value='gemz' pt='md'>
        <GemzTable />
      </Tabs.Panel>
      <Tabs.Panel value='tags' pt='md'>
        <TagsManager />
      </Tabs.Panel>
    </Tabs>
  )
}

export default CommunityGemzTab
